import React from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import { VehicleDriverComponent } from '../VehicleDriverComponent';

const OtherDetailsCard = React.memo(function OtherDetailsCard({
  state,
  onChange,
  onAffiliateChange,
  vehicleDriverRef,
  errors,
}) {
  const { notesTab = 'trip' } = state;

  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-green" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-green"><i className="fas fa-sticky-note" /></span>
        <span className="rx-card-title">Other Details &amp; Notes</span>
      </div>
      <div className="rx-card-body">
        <div className="rx-cols-3">
          <div className="rx-fg">
            <label>Service Source</label>
            <select className="rx-ff" name="serviceSourceId" value={state.serviceSourceId} onChange={onChange} disabled>
              <option value="1">In House</option>
              <option value="2">Farm In</option>
              <option value="3">Farm Out</option>
            </select>
          </div>
          <VehicleDriverComponent ref={vehicleDriverRef} />
        </div>
        {state.serviceSourceId != 1 && (
          <div className="rx-fg">
            <label>Affiliate <span className="req">*</span></label>
            <SelectBox dataSource={state.dropdownAffiliates} placeholder="Select affiliate" name="otherAffiliateId" defaultValue={0} value={state.otherAffiliateId} displayExpr="name" valueExpr="id" onSelectionChanged={onAffiliateChange} showClearButton={true} searchEnabled={true} />
            {errors.otherAffiliateId.length > 0 && <span className="rx-err">{errors.otherAffiliateId}</span>}
          </div>
        )}
        <div style={{ marginTop: 12 }}>
          <div className="rx-tab-bar">
            <button type="button" className={`rx-tab-b${notesTab === 'trip' ? ' active' : ''}`} onClick={() => onChange({ target: { name: 'notesTab', value: 'trip', type: 'text' } })}>Trip Notes</button>
            <button type="button" className={`rx-tab-b${notesTab === 'bill' ? ' active' : ''}`} onClick={() => onChange({ target: { name: 'notesTab', value: 'bill', type: 'text' } })}>Bill To / Pax</button>
            <button type="button" className={`rx-tab-b${notesTab === 'pickup' ? ' active' : ''}`} onClick={() => onChange({ target: { name: 'notesTab', value: 'pickup', type: 'text' } })}>Pick-up</button>
          </div>
          <div className="rx-notes-wrap">
            {notesTab === 'trip' && (
              <textarea className="rx-notes-textarea" rows="4" name="specialInstruction" placeholder="Enter trip / special instruction notes..." maxLength="500" value={state.specialInstruction} onChange={onChange} />
            )}
            {notesTab === 'bill' && (
              <textarea className="rx-notes-textarea" rows="4" name="billToNotes" placeholder="Enter bill to / pax notes..." maxLength="1000" value={state.billToNotes} onChange={onChange} />
            )}
            {notesTab === 'pickup' && (
              <textarea className="rx-notes-textarea" rows="4" name="pickupNotes" placeholder="Enter pick-up notes..." maxLength="1000" value={state.pickupNotes} onChange={onChange} />
            )}
          </div>
          <div className="rx-remark-wrap">
            <div className="rx-remark-label">Permanent Remark</div>
            <textarea className="rx-remark-textarea" rows="2" name="permanentRemark" placeholder="Permanent remark..." maxLength="500" value={state.permanentRemark} onChange={onChange} />
          </div>
        </div>
      </div>
    </div>
  );
});

export default OtherDetailsCard;
